import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { numberComparatorMax2, numberComparatorMax3, numberFilterParams, numberFilterParamsWithThreeDigits, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("poll"),
            field: "Encuesta",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison"],
        config: {
            headerName: getLocalizedString("answer"),
            field: "RESPUESTA",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("answer"),
            field: "RESPUESTA",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("votos"),
            field: "VOTOS",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["nonAnonymousPollComparison", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("code"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["nonAnonymousPollComparison", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRES",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["nonAnonymousPollComparison", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "TIPO DE FUNCIONARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "LUGAR DE TRABAJO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCION",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "TIPO DE CONTRATO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO DE GESTION",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },

    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["nonAnonymousPollComparison", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "OBRA O FAENA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("category"),
            field: "CATEGORIA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["nonAnonymousPollComparison", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("specialty"),
            field: "Especialidad",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("sex"),
            field: "SEXO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("age"),
            field: "EDAD",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("civilState"),
            field: "ESTADO CIVIL",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("nationality"),
            field: "NACIONALIDAD",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },

    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("comuna"),
            field: "COMUNA",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("region"),
            field: "REGION",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: "SINDICATO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config:
        {
            headerName: getLocalizedString("shift"),
            field: "TURNO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.pollComparison, "nonAnonymousPollComparison", "pollComparisonNPS", "nonAnonymousPollComparisonNPS"],
        config: {
            headerName: getLocalizedString("contratista"),
            field: "CONTRATISTA",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        },
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("poll"),
            field: "Encuesta",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("answer"),
            field: "Respuesta",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["pollComparisonSentiments"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
]